<template>
	<div class="flex flex-col items-center py-8 md:py-16">
		<div class="flex items-center py-2 text-sm md:items-center">
			<UIcon
				name="i-lucide-map-pin"
				class="h-8 w-8 shrink-0 text-primary"
			/>
			<div class="flex flex-col md:flex-row">
				<span class="font-semibold">
					{{ address }}
				</span>

				<NuxtLink
					:to="localePath('/get-fiber')"
					class="text-primary md:px-2"
				>
					{{ $t('get-fiber.change') }}
				</NuxtLink>
			</div>
		</div>
		<h2 class="py-4 mt-8 font-normal">
			{{ $t('get-fiber.already-registered-page.h2') }}
		</h2>
		<div class="flex flex-col items-center w-full max-w-lg px-4 text-center md:space-x-12 md:items-end md:flex-row">
			<div class="w-full">
				<div class="px-8 py-4 md:px-0">
					{{ $t('get-fiber.already-registered-page.yes') }}
				</div>
				<UButton
					:ui="{
						label: 'uppercase font-bold'
					}"
					@click="handleSignIn"
				>
					{{ $t('get-fiber.already-registered-page.sign-in') }}
				</UButton>
			</div>
			<div class="w-full">
				<div class="px-8 py-4 md:px-0">
					{{ $t('get-fiber.already-registered-page.no') }}
				</div>
				<UButton
					:ui="{
						label: 'uppercase font-bold'
					}"
					@click="handleContactUs"
				>
					{{ $t('get-fiber.already-registered-page.contact-us') }}
				</UButton>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useAddressLocalStorage } from '@/composables/useLocalStorage'

const localePath = useLocalePath()

const { cachedAddressResponse } = useAddressLocalStorage()

const address = computed(() => {
	return cachedAddressResponse?.value?.address
})

const handleSignIn = () => {
	navigateTo({ path: localePath('/login') })
}
const handleContactUs = () => {
	navigateTo({ path: localePath('/contact') })
}
</script>
